import { UTILS } from '../functions/utils';

export const ROLES = {
  AKSIA_EMPLOYEE: 'AksiaEmployee',
  ADMIN: 'O2-Admin',
  LEGAL_DOC: 'O2-LegalDocTeam',
  DATA: 'O2-DataTeam',
  INVESTMENT_RESEARCH: 'O2-InvestmentResearchTeam',
  RISK: 'O2-RiskTeam',
  CLIENT_OPS: 'O2-ClientOps',
  ODD: 'O2-ODDTeam',
  COMPLIANCE: 'O2-ComplianceTeam',

  CLIENT_DELIVERABLES: 'Client Deliverables',
  DOCUMENT_MANAGEMENT_ADMIN: 'Document Management Admin',
  OPS_AND_ACCOUNTING: 'Ops & Accounting',
  DOCUMENT_MANAGEMENT_VIEW_ONLY: 'Document Management View Only',
  OPS_FEES: 'Ops Fees',
  OPS_LEGAL: 'Ops Legal',
  RISK_TEAM: 'Risk Team',
  CAPITAL_ACCOUNT_STATEMENT: 'Capital Account Statement Access',
  CASH_FLOW_TRANSACTIONS: 'Cash Flows / Transactions Access',

  ACTIVITY_PUBLISHER: 'Allow Publishing',
  ACTIVITY_ADMIN: 'Publish Admin',
  ACTIVITY_STICKY_DATES_PARTNERS: 'Partners',
  ACTIVITY_STICKY_DATES_IDD: 'IDD Heads',
  CEDRIC_ADMIN: 'IT',
  RESTRICTED_WORDS: 'Restricted Words Admin',
  REPLACE_ENTITIES: 'Replace Entities',
  AI_TOPIC_ADMIN: 'AI Topic Admin',
  VALUATION_TEAM: 'Valuation Team',
  DOCUMENT_MANAGER_BETA_ACCESS: 'Document Manager Beta Access',

  toKeyValue: UTILS.KEYVALUE.toKeyValue,
  getKeyFromValue: UTILS.KEYVALUE.getKeyFromValue,
} as const;

export type TCompleteRole = (typeof ROLES)[keyof typeof ROLES];

export type TRole = Omit<TCompleteRole, 'toKeyValue' | 'getKeyFromValue'>;

export const PERMISSIONS = {
  NONE: 'None',
  VIEW: 'View',
  WRITE: 'Write',

  toKeyValue: UTILS.KEYVALUE.toKeyValue,
} as const;

export type PermissionType = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export type TPreferences = {
  theme?: 'light' | 'dark';
  defaultView?: string;
  minimizedSections?: Array<string>;
  minimizedSectionGroups?: Array<string>;
  pinnedSections?: Array<string>;
  impersonatedRole?: TRole;
  extractionViews?: Array<unknown>;
  clientOpsExtractionViews?: Array<unknown>;
};
